import { render, staticRenderFns } from "./OmfyKeyShortcutModal.vue?vue&type=template&id=8865bc6c&scoped=true&"
import script from "./OmfyKeyShortcutModal.vue?vue&type=script&lang=js&"
export * from "./OmfyKeyShortcutModal.vue?vue&type=script&lang=js&"
import style0 from "./OmfyKeyShortcutModal.vue?vue&type=style&index=0&id=8865bc6c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8865bc6c",
  null
  
)

export default component.exports